import dateFnsFormat from "date-fns/format";

export const DATE_FORMAT = "MM/dd/yyyy";
export const FULL_DATE_FORMAT = "MMMM dd, yyyy";

export const format = (date: number | Date, longDate?: boolean) =>
  dateFnsFormat(date, longDate ? FULL_DATE_FORMAT : DATE_FORMAT);
